import { atom } from "recoil";
import { ScriptMap } from '../../components/modals/ScriptingModal/ScriptingTypes'

const scriptsAtom = atom({
  key: 'scriptsAtom',
  default: {} as ScriptMap
})

export default scriptsAtom
